import React, { useEffect, useState } from "react";
import styled, { withTheme } from "styled-components";
import { EmailInput } from "../../ui-library/AuthControls/EmailInput";
import { Button } from "../../ui-library/AuthControls/Button";
import Alert from "../../ui-library/Alert/Alert";
import { emailRegex, FieldsValidation } from "../../../modules/constants";
import { useTranslation } from "react-i18next";

const StyledError = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: ${(props) => props.theme?.cardinal};
  text-transform: uppercase;
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-weight: 600;
  color: ${(props) => props.theme?.nero};
  opacity: 0.63;
  margin-bottom: 20px;
`;

const PasswordRecovery = (props) => {
  const { submittedRecover, onRecover, onDone } = props;

  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [validEmail, setValidEmail] = useState(false);

  const handleRecover = (e) => {
    e.preventDefault();
    onRecover(email);
  };

  const onEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleDone = (e) => {
    e.preventDefault();
    onDone();
  };

  useEffect(() => {
    if (
      (email && !emailRegex.test(email)) ||
      email?.length >= FieldsValidation.email.size ||
      !email
    ) {
      setValidEmail(false);
    } else {
      setValidEmail(true);
    }
  }, [email]);

  return submittedRecover ? (
    <div data-testid="success-modal">
      <Alert email={email} callback={handleDone} />
    </div>
  ) : (
    <form
      onSubmit={handleRecover}
      className="auth-form"
      data-testid="password-recovery-modal"
    >
      <Subtitle>{t("contentText.passwordRecovery.help")}</Subtitle>
      <EmailInput placeholder="Email" onChange={onEmailChange} value={email} />
      <StyledError>
        {email && !validEmail && <span>{t("errorText.invalid.email")}</span>}
      </StyledError>
      <Button text={t("appText.submit")} disabled={!validEmail} />
    </form>
  );
};

export default withTheme(PasswordRecovery);
